import CompareBasket from './CompareBasket'

export default CompareBasket
